<template>
  <div class="company-container">
    <div class="company-header">
      <h1>Company Information</h1>
    </div>

    <!-- Loading State -->
    <div v-if="loading" class="loading">
      Loading company data...
    </div>

    <!-- Error State -->
    <div v-if="error" class="error-message">
      {{ error }}
    </div>

    <!-- Company Form -->
    <div v-if="!loading && company" class="company-form">
      <form @submit.prevent="handleSubmit">
        <div class="form-group">
          <label for="name">Company Name *</label>
          <input
            id="name"
            v-model="formData.name"
            type="text"
            required
            placeholder="Enter company name"
          />
        </div>

        <div class="form-group">
          <label for="city">City</label>
          <input
            id="city"
            v-model="formData.city"
            type="text"
            placeholder="Enter city"
          />
        </div>

        <div class="form-group">
          <label for="address">Address</label>
          <input
            id="address"
            v-model="formData.address"
            type="text"
            placeholder="Enter address"
          />
        </div>

        <div class="form-group">
          <label for="pin">PIN</label>
          <input
            id="pin"
            v-model="formData.pin"
            type="text"
            placeholder="Enter PIN"
          />
        </div>

        <div class="form-actions">
          <button 
            type="submit" 
            class="btn btn-primary"
            :disabled="saving"
          >
            {{ saving ? 'Updating...' : 'Update' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'Company',
  
  data() {
    return {
      saving: false,
      formData: {
        name: '',
        city: '',
        address: '',
        pin: ''
      }
    };
  },

  computed: {
    ...mapState('company', ['company', 'loading', 'error'])
  },

  async mounted() {
    console.log('Component mounted');
    try {
      await this.fetchCompany();
      console.log('Fetched company:', this.company);
      this.initializeForm();
    } catch (error) {
      console.error('Error fetching company:', error);
    }
  },

  methods: {
    ...mapActions('company', ['fetchCompany', 'updateCompany']),

    initializeForm() {
      console.log('Initializing form with company:', this.company);
      if (this.company) {
        this.formData = {
          name: this.company.name || '',
          city: this.company.city || '',
          address: this.company.address || '',
          pin: this.company.pin || ''
        };
        console.log('Form data:', this.formData);
      }
    },

    async handleSubmit() {
      this.saving = true;
      try {
        await this.updateCompany(this.formData);
        alert('Company updated successfully!');
      } catch (error) {
        alert('Failed to update company: ' + error.message);
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.company-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.company-header {
  margin-bottom: 30px;
}

.company-header h1 {
  font-size: 28px;
  font-weight: 600;
}

.loading, .error-message {
  padding: 20px;
  text-align: center;
  border-radius: 8px;
}

.error-message {
  background-color: #fee;
  color: #c00;
}

.company-form {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

.form-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.form-actions {
  margin-top: 30px;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
}

.btn-primary {
  background-color: #007bff;
  color: white;
}

.btn-primary:hover {
  background-color: #0056b3;
}

.btn-primary:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
</style>